module.exports = __webpack_public_path__ + "static/subset-UniNeueBold-Italic-e3613ad853a3f3f39f5a0958faeb1ca9.woff";